/* template */
<template><page><sticky-basic/></page></template>
/* styles */
<style lang="stylus" mpxStyleOptions='{"mid":"_085f6b62"}'>
.cube-sticky-demo-item
  margin-bottom 20px
</style>

/* json */
/* script */
<script>
  import { processComponentOption, getComponent, getWxsMixin } from "@mpxjs/webpack-plugin/lib/runtime/optionProcessor"
  var wxsModules = {}
  global.currentModuleId = "_085f6b62"
  global.currentSrcMode = "wx"
  global.currentInject = {"moduleId":"_085f6b62"}
  /** script content **/
  require("./index.mpx.js?isPage!=!@mpxjs/webpack-plugin/lib/selector?mode=web&env=!./index.mpx?ctorType=page&index=0&isPage&lang=js&mpx&type=script")

  export default processComponentOption({
    option: global.__mpxOptionsMap["_085f6b62"],
    ctorType: "page",
    outputPath: "",
    pageConfig: {},
    // @ts-ignore
    componentsMap: {'sticky-basic':getComponent(require("./sticky-basic.mpx?isComponent&outputPath=components%2Fsticky-basic2ad7e0ca%2Findex")),'base-container':getComponent(require("../../components/base-container/index.mpx?isComponent&outputPath=components%2Findexa53ae8d2%2Findex")),'cube-sticky':getComponent(require("../../../packages/mpx-cube-ui/src/components/sticky/index.mpx?isComponent&outputPath=components%2Findex580e16a0%2Findex")),'cube-sticky-ele':getComponent(require("../../../packages/mpx-cube-ui/src/components/sticky/sticky-ele/index.mpx?isComponent&outputPath=components%2Findex639a4e0d%2Findex"))},
    componentGenerics: {},
    genericsInfo: undefined,
    wxsMixin: getWxsMixin(wxsModules),
    hasApp: true
  })
</script>